{
  "acceptedFileFormats": "Sono accettati solo i file .docx, .pdf e .txt.",
  "actionCompetenceGroup": "Gruppo di Competenza Azione",
  "actionDeadline": "Scadenza dell'Azione",
  "actionDescription": "Descrizione Azione",
  "actionDuration": "Durata dell'Azione",
  "actionEarliestStart": "Inizio Anticipato dell'Azione",
  "actionName": "Nome Azione",
  "actions": "Azioni",
  "actionsAndProjects": "Azioni e Progetti",
  "actionsColon": "Azioni: ",
  "actionsPerformerConstraints": "Vincoli Esecutore Azioni",
  "add": "Aggiungi",
  "addAdmin": "Aggiungi Admin",
  "addAdminTitle": "Aggiungi Admin",
  "addAnalyses": "Aggiungi analisi",
  "addAnalysis": "Aggiungi Analisi",
  "addAnalysisGroup": "Aggiungi un gruppo di analisi",
  "addChatbot": "Aggiungi chatbot",
  "addCompetenceGroup": "Aggiungi Gruppo di Competenza",
  "addConstraint": "Aggiungi vincolo",
  "addGreyTask": "Aggiungi un'attività grigia",
  "addInstrument": "Aggiungi uno Strumento",
  "addItemPlaceholder": "Aggiungi {{item}}...",
  "addLocation": "Aggiungi posizione",
  "addMaintenance": "Aggiungi manutenzione",
  "addMember": "Aggiungi membro",
  "addNewBundle": "Aggiungi Nuovo Bundle",
  "addNewMaintenanceFor": "Aggiungi nuova manutenzione per {{assetName}}",
  "addNewTask": "Aggiungi una nuova attività",
  "addOffsite": "Aggiungi OFFSITE",
  "addProjectGroup": "Aggiungi un gruppo di progetto",
  "addProjectTemplate": "Aggiungi Modello di Progetto",
  "addRepository": "Aggiungi repository",
  "addRow": "Aggiungi Riga",
  "addSample": "Aggiungi campione",
  "addSamples": "Aggiungi campioni",
  "addTeam": "Aggiungi team",
  "additionalInformation": "Informazioni Aggiuntive",
  "administrators": "Amministratori",
  "advanced": "Avanzate",
  "allFilesProcessed": "Tutti i file caricati sono stati elaborati",
  "allowMembersMoveOthersOperationalTasks": "Consenti ai membri di spostare le attività operative di altri",
  "allowedCompetenceGroups": "Gruppi di Competenza Consentiti",
  "allowedInstruments": "Strumenti consentiti",
  "amountOfSamples": "Numero di campioni: {{count}}",
  "analyses": "Analisi",
  "analysesRelatedTo": "Analisi relative a {{product}}",
  "analysis": "Analisi",
  "analysisAndSampleDone": "L'analisi e il campione sono completati",
  "analysisDefinition": "definizione di analisi",
  "analysisDesignTool": "Strumento di Progettazione Analisi",
  "analysisDone": "L'analisi è completata",
  "analysisDraft": "Analisi BOZZA",
  "analysisGroup": "Gruppo di analisi",
  "analysisGroupName": "Nome Gruppo Analisi",
  "analysisIsFlagged": "L'analisi è contrassegnata",
  "analysisMustContainTaskDefinition": "L'analisi deve contenere una definizione di attività",
  "analysisName": "Nome Analisi",
  "analysisNameMustBeUnique": "Il Nome Analisi deve essere univoco",
  "analysisNotPlanned": "Questa analisi non è pianificata",
  "analysisPlanned": "L'analisi è pianificata",
  "analysisTaskBundle": "Bundle Attività Analisi {{index}}",
  "cdmoTargetedBundle": "Raggruppa attività per nome analisi",
  "analysisTaskTimePerformerSamples": "Attività Analisi - Tempo, Esecutore, Numero di Campioni",
  "analysisTasks": "attività di analisi",
  "analysisTasksToBundle": "Attività Analisi da Raggruppare",
  "analysisTimePercentage": "Percentuale di tempo di analisi rispetto al tempo totale (A2T)",
  "anywhere": "Ovunque",
  "apiToken": "Token API",
  "archiveMember": "Archivia Membro",
  "archived": "archiviato",
  "areYouSureConnection": "Sei sicuro di voler creare questa connessione?",
  "areYouSureConnectionMode": "Sei sicuro di voler passare alla modalità \"con connessione\"? Questo rimuoverà tutte le connessioni attuali",
  "areYouSureDeleteAdmin": "Sei sicuro di voler eliminare questo admin?",
  "areYouSureDiscardSimulation": "Sei sicuro di voler scartare i cambiamenti apportati in modalità simulazione?",
  "areYouSurePublishSimulation": "Sei sicuro di voler pubblicare i cambiamenti apportati in modalità simulazione?",
  "areYouSureReset": "Sei sicuro di voler ripristinare? Questo rimuoverà tutti i nodi.",
  "areYouSureUnplanAllFutureActions": "Sei sicuro di voler pianificare tutte le azioni future in questo progetto?",
  "areYouSureWantToExit": "Sei sicuro di voler uscire?",
  "arrival": "Arrivo",
  "assetAddedOrRemoved": "L'asset è stato aggiunto o rimosso",
  "assetRequirementsForAsset": "Requisiti Asset per Asset {{index}}",
  "assets": "Asset",
  "atLeast1LowercaseLetter": "almeno 1 lettera minuscola",
  "atLeast1Number": "almeno 1 numero",
  "atLeast1UppercaseLetter": "almeno 1 lettera maiuscola",
  "atLeast8Characters": "almeno 8 caratteri",
  "automaticImportConversionSheet": "Foglio di Conversione Importazione {{type}} Automatico",
  "automaticSheetConfiguration": "Configurazione Foglio Automatica",
  "availability": "Disponibilità",
  "availableTimeOneWeek": "Tempo disponibile una settimana: ",
  "avgAnalysisDuration": "Durata media analisi: ",
  "avgSampleBatchInterval": "Intervallo medio lotto campioni: ",
  "avgSamplesAllocated": "Numero medio di campioni allocati: ",
  "backlog": "Arretrato",
  "booked": "Prenotato",
  "bookedBy": "Prenotato da",
  "byCompetenceGroup": "Per Gruppo di Competenza",
  "byDeadline": "Per Scadenza",
  "byGroup": "Per Gruppo",
  "byText": "Per Testo",
  "canBePerformedAnywhere": "Può essere eseguito ovunque",
  "canOnlyBePerformedOnSite": "Può essere eseguito solo in loco",
  "cancel": "Annulla",
  "cancelChanges": "Annulla Cambiamenti",
  "cannotUnlockStartedTasks": "Non puoi sbloccare questo poiché una o più attività sono iniziate/in pausa/completate",
  "changeLogs": "Registri Modifiche",
  "changesHaveBeenMade": "Sono state apportate modifiche, ricarica per nuovi dati",
  "chatbotGreeting": "Ciao, sono il tuo CHATBOT AI, specializzato nella documentazione di aiuto di Plannertech e Librarian, e nei repository di dati che hai importato.\nPuoi anche sempre contattare il nostro Supporto Umano su pt@arnvind.com dalle 9-16 CET.\nCome posso aiutarti? :-)",
  "chatbotName": "Nome Chatbot",
  "chatbotPlaceholder": "Scrivi una breve descrizione di come dovrebbe comportarsi il chatbot.",
  "chatbots": "Chatbot",
  "chattingWith": "Chatting con {{name}}",
  "chooseAction": "Scegli Azione",
  "chooseTask": "Scegli Attività",
  "chooseWhatToAdd": "Scegli cosa aggiungere",
  "cleanUp": "Ripulisci",
  "clear": "Cancella",
  "clearConversation": "Cancella la conversazione",
  "clearDates": "Cancella Date",
  "clearTable": "Cancella Tabella",
  "clickToSelectOtherFiles": "Fai clic per selezionare altri file",
  "close": "Chiudi",
  "closeMessage": "chiudi messaggio",
  "closePanel": "Chiudi pannello",
  "collaborator": "Collaboratore",
  "collaborators": "Collaboratori",
  "domain": "Dominio",
  "color": "Colore",
  "columnName": "Nome Colonna",
  "companyWideChatbot": "Chatbot in tutta l'azienda",
  "competenceAndInstrumentConstraints": "Vincoli di Competenza e Strumento",
  "competenceGroup": "Gruppo di Competenza",
  "competenceGroupNameExists": "Un gruppo di competenza con quel nome esiste già",
  "competenceGroups": "Gruppi di Competenza",
  "competenceGroupsColon": "Gruppi di Competenza: ",
  "configuration": "Configurazione",
  "confirm": "Conferma",
  "confirmArchivalOfMember": "Conferma archiviazione del membro: {{initials}}",
  "confirmClearTable": "Sei sicuro di voler cancellare la tabella?",
  "confirmDeleteAllData": "Confermando questo eliminerai tutti i dati {{type}}. Non c'è ritorno, nemmeno con Modalità Simulazione.",
  "confirmDeleteAllUnplannedProjects": "Confermando questo eliminerai tutti i progetti che non hanno azioni collocate nel piano",
  "confirmDeleteAllUnplannedSamples": "Confermando questo eliminerai tutti i campioni che non hanno azioni collocate nel piano",
  "confirmDeleteCompetenceGroup": "Conferma eliminazione del gruppo di competenza:",
  "confirmDeleteInstrument": "Sei sicuro di voler eliminare lo strumento: {{name}}?",
  "confirmDeleteMaintenance": "Sei sicuro di voler eliminare questa manutenzione?",
  "confirmDeleteSample": "Sei sicuro di voler eliminare questo campione non pianificato?",
  "confirmDeleteSampleInfo": "Confermando questo eliminerai permanentemente il campione selezionato",
  "confirmDeletion": "Conferma eliminazione",
  "confirmFailSamples": "Sei sicuro di voler fallire i campioni selezionati?",
  "confirmFailSamplesInfo": "Confermando questo farà fallire i campioni selezionati. Un duplicato verrà posizionato nel menu di analisi non pianificato",
  "confirmFailSamplesQuestion": "Sei sicuro di voler fallire i campioni selezionati?",
  "confirmShowPlannedSamplesInfo": "Confermando questo mostrerà i campioni pianificati",
  "confirmShowPlannedSamplesQuestion": "Sei sicuro di voler mostrare i campioni pianificati?",
  "confirmSortByTime": "Sei sicuro di voler ordinare per tempo",
  "confirmUnplanAllFutureActions": "Sei sicuro di voler deschi il piano di tutte le azioni future in questo progetto?",
  "confirmUnplanAllQuestion": "Sei sicuro di voler deschi il piano di tutti {{itemType}}?",
  "confirmUnplanSamplesInfo": "Confermando questo toglierà dal piano i campioni selezionati. Verrà collocato nel menu di analisi non pianificato",
  "confirmUnplanSamplesQuestion": "Sei sicuro di voler togliere dal piano i campioni selezionati?",
  "connectionCalculatedInWorkdays": "Connessione calcolata in giorni lavorativi",
  "connectionCount": "Numero Connessioni",
  "connections": "Connessioni",
  "connectionsAdvancedWarning": "(L'uso di connessioni con scadenza o inizio più prematuro su azioni è per utenti avanzati)",
  "connectionsPerformersOnly": "Le connessioni sono solo esecutori - non influiscono sull'allocazione degli asset",
  "contactArnvindSupport": "Si prega di contattare il supporto Arnvind su pt@arnvind.com",
  "conversionSheet": "Foglio di Conversione",
  "copyToClipboard": "copia negli appunti",
  "country": "Paese",
  "create": "Crea",
  "createANewColumn": "Crea una nuova Colonna",
  "createAction": "Crea Azione",
  "createChatbot": "Crea chatbot",
  "createEditChatbots": "Crea/modifica chatbot",
  "createEditRepositories": "Crea/modifica repository",
  "createNewColumn": "Crea una nuova Colonna",
  "createNewProject": "Crea Nuovo Progetto",
  "createSingleAction": "Crea Azione Singola",
  "createStage": "Crea Fase",
  "createStandardAction": "Crea Azione Standard",
  "currentlyProcessingRepository": "Elaborazione di questo repository in corso",
  "daily": "Giornalmente",
  "date": "Data",
  "dateUnavailable": "Data Non Disponibile",
  "day": "giorno",
  "dayS": "giorno/i",
  "days": "giorno/i",
  "daysBeforeExpirationWarning": "Giorni prima della scadenza per mostrare l'avviso",
  "daysBetweenRecurrences": "Giorni Tra le Ricorrenze",
  "deadline": "Scadenza",
  "deadlineColon": "Scadenza: ",
  "deadlineDate": "Data Scadenza",
  "deadlineMustBeLaterThanEarliestStart": "La scadenza deve essere successiva o uguale all'inizio anticipato",
  "deadlineTime": "Ora Scadenza",
  "defaultChatbot": "Chatbot predefinito",
  "delete": "Elimina",
  "deleteAllTypeTestData": "Elimina tutti i Dati di Test {{type}}",
  "deleteAllUnplannedProjects": "Elimina Tutti i Progetti Non Pianificati",
  "deleteAllUnplannedSamples": "Elimina Tutti i Campioni Non Pianificati",
  "deleteColumn": "Elimina Colonna",
  "deleteCompetenceGroup": "Elimina Gruppo di Competenza",
  "deleteCompetenceGroupWarning": "L'eliminazione di questo lascerà le attività nelle seguenti analisi senza un Gruppo di Competenza. Assicurati di sostituire prima della rimozione.",
  "deleteConstraint": "Elimina vincolo",
  "deleteData": "Elimina Dati",
  "deleteInstrument": "Elimina Strumento",
  "deleteInstrumentWarning": "Verrà eliminato anche per altri team in questa posizione.",
  "deleteProjects": "Elimina Progetti",
  "deleteSample": "Elimina Campione",
  "deleteSamples": "Elimina Campioni",
  "deleteThisRow": "Elimina questa riga",
  "description": "Descrizione",
  "designTool": "Strumento di Progettazione",
  "done": "Completato",
  "draft": "bozza",
  "dragAndDropFiles": "Trascina i file qui, o fai clic per selezionare i file",
  "dragAndDropFolders": "Trascina le cartelle qui, o fai clic per selezionare file specifici",
  "dropFilesHere": "Rilascia i file qui",
  "dropFoldersHere": "Rilascia le cartelle qui...",
  "duplicate": "Duplica",
  "durationHHMM": "Durata (HH:MM)",
  "earliestStart": "Inizio Anticipato",
  "edit": "Modifica",
  "editAction": "Modifica Azione",
  "editAdmin": "Modifica Admin",
  "editAnalysisGroup": "Modifica gruppo di analisi",
  "editAnalysisTask": "Modifica attività di Analisi",
  "editChatbot": "Modifica chatbot",
  "editCompetenceGroup": "Modifica Gruppo di Competenza",
  "editConnectionFromTo": "Modifica connessione da {{from}} a {{to}}",
  "editConversation": "Modifica Conversazione",
  "editGroup": "Modifica gruppo",
  "editInstrument": "Modifica Strumento",
  "editItem": "Modifica {{item}}",
  "editLocationName": "Modifica nome posizione",
  "editMaintenanceFor": "Modifica {{name}} per {{assetName}}",
  "editMember": "Modifica membro",
  "editOffsite": "Modifica OFFSITE",
  "editProject": "Modifica Progetto",
  "editProjectGroup": "Modifica gruppo di progetto",
  "editProjectTemplate": "Modifica Modello di Progetto",
  "editProjectTemplateDraft": "Modifica Modello di Progetto BOZZA",
  "editRepository": "Modifica repository",
  "editSampleName": "Modifica campione: {{name}}",
  "editSheet": "Modifica Foglio {{name}}",
  "editStandardAction": "Modifica Azione Standard",
  "editTask": "Modifica attività",
  "editTeam": "Modifica team",
  "edited": "Modificato",
  "email": "e-mail",
  "emailCannotContainDoubleDots": "L'indirizzo email non può contenere '..' consecutivi",
  "emailLabel": "Email",
  "endDate": "Data Fine",
  "enterSimulationMode": "Accedi alla Modalità Simulazione",
  "errors": "Errori",
  "errorsProcessingRepository": "Ci sono stati errori durante l'elaborazione di questo repository",
  "estimatedWorkloadOneWeek": "Carico di lavoro stimato una settimana: ",
  "exclusive": "Esclusivo",
  "exclusiveSampleIndicator": "* Indica un campione esclusivo",
  "exitSimulation": "ESCI SIMULAZIONE",
  "exitSimulationMode": "Esci dalla modalità simulazione",
  "expand": "Espandi",
  "exportToExcel": "Esporta in Excel",
  "fail": "Fallisci",
  "failSample": "Fallisci Campione",
  "failSelected": "Fallisci Selezionato",
  "failedLoading": "Caricamento non riuscito: {{members}}",
  "failedToCreateMaintenance": "Impossibile creare la manutenzione \"{{name}}\"",
  "failedToDeleteMaintenance": "Impossibile eliminare la manutenzione \"{{name}}\"",
  "failedToMarkMaintenanceAsCompleted": "Impossibile contrassegnare la manutenzione \"{{name}}\" come completata",
  "failedToUpdateMaintenance": "Impossibile aggiornare la manutenzione \"{{name}}\"",
  "failedUploads": "Caricamenti Non Riusciti",
  "fileUpload": "Caricamento File",
  "fileUploadError": "Si è verificato un errore durante il caricamento del file",
  "filenameLabel": "Nome file: ",
  "filesUploadedSuccessfully": "File caricati con successo",
  "fillIn": "Compila",
  "fillInIgnoreOverbooking": "Compila Ignora Sovraprenotazione",
  "filter": "Filtro",
  "filterByName": "Filtra per Nome",
  "filterBySampleName": "Filtra per Nome Campione",
  "filterBySampleProductName": "Filtra per Nome Campione/Prodotto",
  "filterByText": "Filtra per Testo",
  "finished": "Terminato",
  "flag": "Contrassegna",
  "flagSample": "Contrassegna Campione",
  "followingErrorsWhileImporting": "Seguenti errori durante l'importazione:",
  "free": "Libero",
  "from": "Da",
  "fromDate": "Da data",
  "fromTime": "Da ora (HH:MM)",
  "fromTimeHH": "Da ora (HH)",
  "fromTimeHHMM": "Da ora (HH:MM)",
  "futureAnalysisTaskCantBe": "Un'attività di Analisi futura non può essere {{state}}",
  "generate": "Genera",
  "globalChatbot": "Chatbot globale",
  "goBack": "Torna indietro",
  "goBackToChat": "Torna alla chat",
  "greyTaskTimePercentage": "Percentuale di tempo attività grigia rispetto al tempo totale (G2T)",
  "groupMembers": "Membri del Gruppo",
  "groupName": "Nome Gruppo",
  "help": "Aiuto",
  "helpBackToApp": "Torna all'app",
  "helpHome": "Home aiuto",
  "helpPageNotFound": "Pagina di aiuto non trovata",
  "helpSearch": "Cerca aiuto",
  "helpAppTitle": "Aiuto Plannertech",
  "hidden": "Nascosto",
  "hideMore": "Nascondi altri",
  "highestPriority": "1 è la priorità più alta",
  "history": "Cronologia",
  "home": "Home",
  "hour": "ora",
  "iCalendarOutlookIntegration": "Integrazione iCalendar / Outlook",
  "iap": "IAP",
  "ignoreAllGreytasks": "Ignora Tutte le Attività Grigie",
  "ignoredByIap": "Ignorato da IAP",
  "includingToday": "Incluso oggi",
  "importedTask": "Attività importata",
  "busyOnAnotherTeam": "Occupato in un altro team",
  "includeDoneSamples": "Includi campioni completati",
  "includeOverdue": "Includi Scaduto",
  "includeToday": "Includi Oggi",
  "iapIncludeTodayWarningIAP": "Avviso IAP e Includi Oggi - le attività pianificate prima oggi possono essere spostate a meno che non siano bloccate!",
  "iapIncludeTodayWarningFillIn": "Avviso Compila e Includi Oggi - le attività pianificate prima oggi possono ricevere nuovi campioni allocati!",
  "initials": "Iniziali",
  "inputLastMonth": "Input Mese Scorso",
  "inputThisMonth": "Input Questo Mese",
  "instrument": "Strumento",
  "instrumentConstraints": "Vincoli Strumento",
  "instrumentLog": "Registro Strumento",
  "instrumentName": "Nome Strumento",
  "instrumentOffset": "Offset strumento (HH:MM)",
  "instrumentOverbooking": "Sovraprenotazione Strumento",
  "instrumentPerSampleDuration": "Durata strumento per campione (HH:MM:SS)",
  "instrumentSetup": "Configurazione Strumento {{name}}",
  "instrumentSetuptime": "Tempo di configurazione strumento (HH:MM)",
  "instrumentTime": "Tempo Strumento",
  "instrumentView": "Visualizzazione Strumento",
  "instruments": "Strumenti",
  "instrumentsWithExpiredMaintenance": "Ci sono strumenti con manutenzione scaduta",
  "instrumentsWithMaintenanceReminders": "Ci sono strumenti con promemoria di manutenzione",
  "integration": "Integrazione",
  "invalidDate": "Data Non Valida",
  "invalidOutlookLink": "Link iCalendar / Outlook non valido",
  "isInSimulationMode": "{{initials}} è in modalità simulazione",
  "isSimulating": "{{initials}} sta simulando...",
  "keepExistingConnections": "Mantieni connessioni esistenti",
  "labelAlreadyLoaded": "Già caricato: {{count}}",
  "labelCreated": "Creato: {{count}}",
  "labelDeleted": "Eliminato: {{count}}",
  "labelDeletedOrFinished": "Eliminato o contrassegnato come completato: {{count}}",
  "labelDoneDeleted": "Completato/Eliminato: {{count}}",
  "labelUpdatedInformation": "Informazioni aggiornate: {{count}}",
  "lastErrorLog": "Ultimo Registro Errori",
  "lastWeek": "La Settimana Scorsa",
  "latestArrival": "Ultimo Arrivo",
  "leadTimesInWorkDays": "Tempi di Lead in Giorni Lavorativi",
  "leaveEmptyIfNotUsed": "(lascia vuoto se non utilizzato)",
  "leaveEmptyIfNotUsedDefault": "(lascia vuoto se non utilizzato, predefinito={{defaultValue}})",
  "loadFromTemplate": "Carica da modello",
  "loading": "CARICAMENTO",
  "loadingEllipsis": "Caricamento...",
  "loadingSamples": "Caricamento campioni",
  "loadingSheet": "Caricamento foglio",
  "loadingSheets": "Caricamento fogli",
  "location": "Posizione",
  "locationColon": "Posizione: {{name}}",
  "locationName": "Nome Posizione",
  "lockItemType": "Blocca {{itemType}}",
  "lockSamples": "Blocca campioni",
  "lockUnlockSamplesLabel": "Blocca/Sblocca campioni:",
  "locks": "Blocchi",
  "locksAllFutureAnalysisTasks": "Blocca tutte le attività di analisi pianificate future",
  "locksAllFutureProjectActions": "Blocca tutte le azioni di progetto pianificate future",
  "login": "Accedi",
  "logout": "Esci",
  "maintenanceCreatedSuccessfully": "Manutenzione \"{{name}}\" creata con successo",
  "maintenanceDeletedSuccessfully": "Manutenzione \"{{name}}\" eliminata con successo",
  "maintenanceExpired": "Manutenzione scaduta",
  "maintenanceExpiresInDays": "La manutenzione scade tra meno di {{days}} giorni",
  "maintenanceMarkedAsCompleted": "Manutenzione \"{{name}}\" contrassegnata come completata",
  "maintenanceName": "Nome manutenzione",
  "maintenanceUpdatedSuccessfully": "Manutenzione \"{{name}}\" aggiornata con successo",
  "mandatoryIfRecurrenceUsed": "(obbligatorio se viene utilizzata la ricorrenza)",
  "manualSample": "Campione manuale",
  "manualSheetConfiguration": "Configurazione Foglio Manuale",
  "markAsDone": "Contrassegna come completato",
  "maxSampleCount": "Numero Massimo Campioni",
  "maxSampleCountLabel": "Numero massimo di campioni: ",
  "maxTimeBetweenActions": "Tempo massimo tra le azioni (GG:HH:MM)",
  "maxTimeBetweenTasks": "Tempo massimo tra le attività (GG:HH:MM)",
  "member": "Membro",
  "memberHasEnabledICalendarOutlookIntegration": "Il Membro ha Abilitato l'Integrazione iCalendar / Outlook",
  "memberHasEnabledOutlook": "Il Membro ha Abilitato l'Integrazione iCalendar / Outlook",
  "memberPermissions": "Autorizzazioni membro",
  "memberPlan": "Piano Membro",
  "memberTime": "Tempo Membro",
  "membersGoDirectlyToMemberPlan": "I membri vanno direttamente al piano membro",
  "message": "Messaggio",
  "metric": "Metrica",
  "minSampleCount": "Numero Minimo Campioni",
  "minSampleMustBeLowerThanMax": "Il numero minimo di campioni deve essere inferiore al massimo",
  "minTimeBetweenActions": "Tempo minimo tra le azioni (GG:HH:MM)",
  "minTimeBetweenTasks": "Tempo minimo tra le attività (GG:HH:MM)",
  "minTimeMustBeSmallerThanMax": "Il tempo minimo tra deve essere inferiore al tempo massimo tra",
  "minimumDuration": "Durata Minima: {{time}}",
  "minute": "minuto",
  "missingPasswordRequirements": "Requisiti password mancanti: {{requirements}}",
  "months": "Mesi",
  "movedBy": "Spostato da",
  "movedFrom": "Spostato da",
  "movedTo": "Spostato a",
  "mustBeIcsLink": "Deve essere un link .ics",
  "name": "Nome",
  "namePerformer": "{{name}} esecutore",
  "nameTooLongTitle": "Nome troppo lungo (max 100 caratteri)",
  "newAnalysisTaskBundle": "Nuovo Bundle Attività Analisi",
  "newChat": "Nuova chat",
  "newInstrument": "Nuovo Strumento",
  "newProject": "Nuovo Progetto",
  "newProjectTemplateDraft": "Nuovo Modello di Progetto BOZZA",
  "newStart": "Nuovo Inizio",
  "nextDay": "Giorno Successivo",
  "nextWeek": "Settimana Successiva",
  "no": "No",
  "noAnalysesForProduct": "Nessuna analisi trovata per questo prodotto.",
  "noAssetsFound": "Nessun asset trovato",
  "noChanges": "Nessun cambiamento",
  "noChatbotSelected": "Nessun chatbot selezionato",
  "noDataFound": "Nessun dato trovato",
  "noErrorsToDisplay": "Nessun errore da visualizzare.",
  "noGroup": "Nessun gruppo",
  "noMembersLoaded": "Nessun membro è stato caricato.",
  "noOfRecurrences": "N. di Ricorrenze",
  "noReferencesAvailable": "Nessun riferimento disponibile.",
  "noSamples": "Nessun campione",
  "noSamplesAvailable": "Nessun campione disponibile",
  "noSearchResults": "Nessun risultato di ricerca",
  "noTimeLimitUnlessSpecified": "Nessun limite di tempo a meno che non sia specificato",
  "none": "Nessuno",
  "default": "Predefinito",
  "notAvailable": "N/A",
  "notEnoughRoomForDuration": "Non c'è abbastanza spazio per la durata",
  "notStarted": "Non Iniziato",
  "numberOfObservations": "Numero di Osservazioni",
  "numberOfRecurrences": "Numero di ricorrenze",
  "numericInputBetweenTimeRange": "Si prega di fornire un input numerico tra 00:00 e 23:59",
  "offsiteCalendar": "Calendario OFFSITE",
  "ok": "Ok",
  "oldInstrument": "Vecchio Strumento",
  "oldStart": "Vecchio Inizio",
  "onlyAdvancedUsersInfo": "Solo gli utenti avanzati usano sia l'inizio anticipato che le connessioni",
  "onsite": "In Loco",
  "openReferences": "Apri Riferimenti",
  "operationalGreyTaskTimePercentage": "Percentuale di tempo attività grigia operazionale rispetto al tempo totale (OG2T)",
  "operationalTask": "Attività Operazionale",
  "otherPlannerSimulating": "{{initials}} è in modalità simulazione",
  "outlookLinkLabel": "Link iCalendar / Outlook",
  "outputLastMonth": "Output Mese Scorso",
  "outputThisMonth": "Output Questo Mese",
  "parentColumn": "Colonna Padre",
  "password": "Password",
  "paused": "In Pausa",
  "peopleSetup": "Configurazione Persone",
  "perSampleDuration": "Durata per campione (HH:MM:SS)",
  "perSampleDurationForPeopleSetup": "Durata Per Campione per Configurazione Persone",
  "performerConstraintsCount": "Numero Vincoli Esecutore",
  "performerConstraintsLabel": "Vincoli Esecutore",
  "permanentApiToken": "Token API permanente",
  "permanentApiTokenDescription": "Questo è un token API permanente, che ti consente di accedere al tuo team tramite la nostra API. Copialo e memorizzalo in un luogo sicuro.",
  "pinConversation": "Fissa conversazione",
  "planned": "Pianificato",
  "planner": "Pianificatore",
  "plannertechLanguage": "Lingua Plannertech",
  "plannertechVariable": "Variabile Plannertech",
  "pleaseChooseColor": "Si prega di scegliere un Colore per l'analisi",
  "pleaseFillOutAnalysisName": "Si prega di compilare il Nome Analisi",
  "pleaseFillOutRequiredTaskParams": "Si prega di compilare i parametri di attività richiesti",
  "pleaseGiveEmptyOrFullInput": "Si prega di fornire input vuoto o completo",
  "pleaseGiveNumericInput": "Si prega di fornire input numerico",
  "pleaseInputValidDate": "Si prega di inserire una data valida",
  "pleaseSelectAtLeastOneItem": "Si prega di selezionare almeno un elemento",
  "pleaseSelectColor": "Si prega di selezionare un colore",
  "pleaseSelectFirstDay": "Si prega di selezionare il primo giorno.",
  "pleaseSelectLastDay": "Si prega di selezionare l'ultimo giorno.",
  "pleaseSelectTimezone": "Si prega di selezionare un fuso orario",
  "previousDay": "Giorno Precedente",
  "primary": "Principale",
  "primaryInstrument": "Strumento Principale",
  "prioritizeByDeadline": "Dare Priorità a IAP per Scadenza",
  "prioritizeByPriority": "Dare Priorità a IAP per Numero di Priorità",
  "priority": "Priorità",
  "priorityHigh": "(Alta)",
  "priorityLow": "(Bassa)",
  "priorityMedium": "(Media)",
  "process": "Processo",
  "processed": "Elaborato",
  "processing": "Elaborazione...",
  "processingInProgress": "Elaborazione",
  "productName": "Nome Prodotto",
  "project": "Progetto",
  "projectActions": "azioni di progetto",
  "projectBatchNumber": "Numero Lotto Progetto",
  "projectDeadline": "Scadenza Progetto",
  "projectDescription": "Descrizione Progetto",
  "projectEarliestStart": "Inizio Anticipato del Progetto",
  "projectGroup": "Gruppo di progetto",
  "projectGroupName": "Nome Gruppo Progetto",
  "projectImport": "Importazione Progetto",
  "projectImportVariable": "Variabile di Importazione Progetto",
  "projectMaterialDescription": "Descrizione Materiale Progetto",
  "projectMaterialNumber": "Numero Materiale Progetto",
  "projectName": "Nome Progetto",
  "projectPriority": "Priorità Progetto",
  "projectReleaseDate": "Data Rilascio Progetto",
  "projectSupplierName": "Nome Fornitore Progetto",
  "projectSupplierNumber": "Numero Fornitore Progetto",
  "projectTemplate": "modello di progetto",
  "projectTemplates": "Modelli di Progetto",
  "projectTimePercentage": "Percentuale di tempo di progetto rispetto al tempo totale (P2T)",
  "projectView": "Visualizzazione Progetto",
  "projects": "Progetti",
  "projectsAndActions": "Progetti e Azioni",
  "promptPrefix": "Prefisso Prompt",
  "promptTooLongTitle": "Prompt troppo lungo (max 1200 caratteri)",
  "publish": "PUBBLICA",
  "publishSimulationChanges": "Pubblica i cambiamenti della modalità simulazione",
  "qcLibrarian": "QC Librarian",
  "qcLibrarianTitle": "QC Librarian 3.8",
  "recur": "Ricorrenza",
  "recurEvery": "Ricorrenza ogni",
  "recurrence": "Ricorrenza",
  "reduce": "Riduci",
  "references": "Riferimenti",
  "rejectedFileTypes": "Tipi di File Rifiutati",
  "rejectedFilesIncompatible": "I seguenti file sono stati rifiutati a causa di formati incompatibili",
  "reminderDaysBeforeEndDate": "Promemoria (giorni prima della data di fine)",
  "remove": "Rimuovi",
  "removeAnalysisFromProduct": "Rimuovi {{name}} da questo prodotto",
  "removeAsset": "Rimuovi Asset",
  "removeEverything": "Rimuovi tutto",
  "removeInstrument": "Rimuovi Strumento",
  "reportGenerator": "Generatore di Report",
  "reports": "Report",
  "repositories": "Repository",
  "repositoryCurrentlyProcessing": "Il repository è attualmente in elaborazione dei file. Si prega di aggiornare la pagina per vedere i progressi",
  "repositoryHasUnprocessedFiles": "Questo repository ha file non elaborati",
  "repositoryIsProcessed": "Questo repository è elaborato",
  "repositoryName": "Nome Repository",
  "reset": "Ripristina",
  "role": "Ruolo",
  "row": "Riga",
  "rowNumber": " riga {{row}}",
  "runIAP": "Esegui IAP",
  "runningIAP": "Esecuzione IAP",
  "sampleAnalysisName": "Nome Analisi Campione",
  "sampleBatchNumber": "Numero Lotto Campione",
  "sampleHighestPriority": "Il campione ha la priorità più alta",
  "sampleId": "ID Campione",
  "sampleIdWithValue": "ID Campione: {{id}}",
  "sampleImport": "Importazione Campione",
  "sampleImportVariable": "Variabile di Importazione Campione",
  "sampleInProgressOnDoneAnalysis": "Campione in corso su analisi completata",
  "sampleIsDone": "Il campione è completato",
  "sampleLog": "Registro Campione",
  "sampleLowestPriority": "Il campione ha la priorità più bassa",
  "sampleMaterialNumber": "Numero Materiale Campione",
  "sampleName": "Nome Campione",
  "sampleObservation": "Osservazione Campione",
  "sampleObservations": "Osservazioni Campione",
  "samplePercentage": "Percentuale campione",
  "sampleProductDescription": "Descrizione Prodotto Campione",
  "sampleReceivedDate": "Data Ricezione Campione",
  "sampleStatus": "Stato Campione",
  "sampleView": "Visualizzazione Campione",
  "samples": "Campioni",
  "samplesWithName": "Campioni con il nome {{name}}",
  "samplesWithoutProduct": "Campioni senza prodotto",
  "save": "Salva",
  "saveAs": "Salva Come",
  "saveAsDraft": "Salva come {{type}} BOZZA",
  "saveAsNew": "Salva come nuovo",
  "saveAsNewAnalysis": "Salva come nuova analisi",
  "saveAsNewTemplate": "Salva come nuovo modello",
  "saveAsType": "Salva come {{type}}",
  "scrollToTop": "Scorri verso l'alto",
  "scrumView": "Visualizzazione Scrum",
  "scrumViewOrdering": "Ordinamento Visualizzazione Scrum",
  "searchBySampleName": "Cerca per nome campione...",
  "searchCountry": "Cerca paese",
  "seats": "Posti",
  "second": "secondo",
  "secondaryInstrumentMustHaveAllowedInstrument": "Lo strumento secondario deve avere almeno uno strumento consentito",
  "selectAll": "Seleziona Tutto",
  "selectChatbot": "Seleziona chatbot",
  "selectDefaultChatbot": "Seleziona chatbot predefinito",
  "selectEntireDay": "Seleziona l'intera giornata",
  "selectEntireWorkday": "Seleziona l'intera giornata lavorativa",
  "selectLocation": "Seleziona posizione...",
  "selectSamples": "Seleziona Campioni",
  "selectState": "Seleziona stato...",
  "selectTimezone": "Seleziona fuso orario...",
  "selectType": "Seleziona Tipo",
  "selectedFilesReadyForSubmit": "File/cartelle selezionati pronti per l'invio:",
  "selectedProduct": "Prodotto Selezionato",
  "setPlannedValues": "Imposta Valori Pianificati",
  "settings": "Impostazioni",
  "settingsForQcLibrarian": "Impostazioni per QC Librarian",
  "setupTimeForPeopleSetup": "Tempo di Configurazione per Configurazione Persone",
  "setuptime": "Tempo di configurazione (HH:MM)",
  "sheetName": "Nome Foglio",
  "sheetNameLabel": "Nome Foglio",
  "sheetType": "Tipo Foglio",
  "shouldBeEqualTo": "dovrebbe essere uguale a",
  "shouldNotBeEqualTo": "non dovrebbe essere uguale a",
  "showAnalyses": "Mostra Analisi",
  "showErrors": "Mostra Errori",
  "showLastErrorLog": "Mostra l'ultimo registro errori",
  "showLibrarian": "Mostra Librarian",
  "showLog": "Mostra Registro",
  "showMore": "Mostra altri",
  "showOnPlan": "Mostra nel Piano",
  "showProjects": "Mostra Progetti",
  "shown": "Visibile",
  "simulationMode": "Modalità Simulazione",
  "simulationModeLogoutWarning": "Sei attualmente in modalità simulazione. La disconnessione scartherà i cambiamenti!",
  "simulationModeOccupied": "MODALITÀ SIMULAZIONE OCCUPATA",
  "simulationModeUpper": "MODALITÀ SIMULAZIONE",
  "somethingWentWrong": "Qualcosa è andato storto",
  "sortByProduct": "Ordina per prodotto",
  "sortByTime": "Ordina Per Tempo",
  "sortByTimeDescription": "Ordina le azioni in Arretrato e Da Fare secondo le loro scadenze, e Pianificate e Terminate secondo il loro tempo di inizio",
  "speechToTextLanguage": "Lingua sintesi vocale",
  "spreadsheetColumnName": "Nome Colonna Foglio di Calcolo",
  "stage": "Fase",
  "standardActions": "Azioni Standard",
  "start": "Inizio",
  "startDate": "Data Inizio",
  "startDateCheckboxInfo": "Quando selezionato, la scadenza del progetto, la scadenza dell'azione e l'inizio dell'azione si sposteranno relativamente all'inizio del progetto",
  "startEndDate": "Data Inizio/Fine",
  "startProcessingInfo": "Questo avvierà l'elaborazione del repository. Potrebbe richiedere un certo tempo a seconda delle dimensioni del repository",
  "startRecurrence": "Inizio Ricorrenza",
  "startTime": "Ora Inizio",
  "started": "Iniziato",
  "state": "Stato",
  "status": "Stato",
  "submit": "Invia",
  "successfullyLoaded": "Caricato con successo: {{members}}",
  "successfullyUploadedFiles": "File Caricati con Successo",
  "systemPrompt": "Prompt di Sistema",
  "taskBelongsToTeam": "L'attività appartiene al team: {{team}}",
  "taskCount": "Numero Attività",
  "taskDesignTool": "Strumento di Progettazione Attività",
  "taskLog": "Registro Attività",
  "taskName": "Nome Attività",
  "taskPerformerConstraints": "Vincoli Esecutore Attività",
  "tasks": "Attività",
  "team": "Team",
  "teamChatbot": "Chatbot team",
  "teamLabel": "Team: {{name}}",
  "teamMember": "Membro Team",
  "teamName": "Nome Team",
  "teamPlan": "Piano Team",
  "teamUsageTitle": "Utilizzo {{name}}",
  "teams": "Team",
  "templateIsDraft": "Questo modello di progetto è una Bozza",
  "templateName": "Nome Modello",
  "theProjectIsDone": "Il progetto è completato",
  "timeConstraints": "Vincoli di Tempo",
  "timeHHMM": "Ora (HH:MM)",
  "timePeriod": "Periodo Temporale",
  "timestamp": "Timestamp",
  "timezone": "Fuso Orario",
  "to": "A",
  "toConfirmDeletionType": "Per confermare l'eliminazione digita {{keyword}}",
  "toConfirmDeletionTypeDeleteData": "Per confermare l'eliminazione digita {{keyword}} e premi conferma. Questo eliminerà permanentemente i dati di test, anche con modalità simulazione. Non c'è ritorno.",
  "toConfirmDeletionTypeKeyword": "Per confermare l'eliminazione digita {{keyword}} e premi conferma",
  "toDate": "A data",
  "toDo": "Da Fare",
  "toTime": "A ora (HH:MM)",
  "toTimeHH": "A ora (HH)",
  "toTimeHHMM": "A ora (HH:MM)",
  "today": "Oggi",
  "tokens": "Token",
  "total": "Totale",
  "normalSeats": "Normale",
  "tryReloadingOrContactSupport": "Prova a ricaricare, o contatta il supporto se il problema persiste!",
  "type": "Tipo",
  "typeBeforeConfirming": "digita {{keyword}} prima di confermare",
  "typeOrSelect": "Digita o seleziona...",
  "typeYourMessage": "Digita il tuo messaggio...",
  "unassignedSamples": "Campioni non assegnati",
  "unassignedSamplesFor": "Campioni non assegnati per \"{{name}}\"",
  "unflag": "Rimuovi contrassegno",
  "unflagSample": "Rimuovi Contrassegno Campione",
  "unlockItemType": "Sblocca {{itemType}}",
  "unlockSamples": "Sblocca campioni",
  "unlocks": "Sblocchi",
  "unlocksAllFutureAnalysisTasks": "Sblocca tutte le attività di analisi pianificate future",
  "unlocksAllFutureProjectActions": "Sblocca tutte le azioni di progetto pianificate future",
  "unnamed": "senza nome",
  "unpinConversation": "Rilascia conversazione",
  "unplan": "Rimuovi dal Piano",
  "unplanAnalysis": "Rimuovi l'Analisi dal Piano",
  "unplanItemType": "Rimuovi {{itemType}} dal Piano",
  "unplanSample": "Rimuovi il Campione dal Piano",
  "unplanSelected": "Togli Selezionato dal Piano",
  "unplanned": "Non Pianificato",
  "unplannedProjects": "Progetti Non Pianificati",
  "unsavedChangesIn": "Sono presenti cambiamenti non salvati in:",
  "updateIntegration": "Aggiorna Integrazione",
  "updatedIcalOutlook": "Aggiornato iCalendar / Outlook!",
  "uploadAborted": "Caricamento interrotto!",
  "uploadComplete": "Caricamento completato!",
  "uploadFailedForFile": "Caricamento non riuscito per il file: {{path}}",
  "uploadFinished": "Caricamento Terminato!",
  "uploadTo": "Carica a {{name}}",
  "usage": "Utilizzo",
  "used": "Utilizzato",
  "usedAssets": "Asset Utilizzati",
  "usedInstrument": "Strumento Utilizzato",
  "usedInstruments": "Strumenti Utilizzati",
  "username": "Nome Utente",
  "value": "Valore",
  "view": "Visualizza",
  "viewAllAnalysesForProduct": "Visualizza tutte le analisi per questo prodotto",
  "viewAnalysisSamples": "Visualizza Campioni Analisi",
  "viewCompact": "Visualizzazione Compatta",
  "viewNormal": "Visualizzazione Normale",
  "weekNumber": "Settimana {{week}}",
  "weekView": "Visualizzazione Settimana",
  "dayView": "Visualizzazione Giorno",
  "weekendView": "Visualizzazione Fine Settimana",
  "screen": "Schermo",
  "clickToSortBy": "Fai clic per ordinare per {{column}}",
  "fileChangedPleaseReselect": "{{file}} è cambiato. Si prega di selezionare di nuovo il file",
  "contentTooWideZoomOut": "Il contenuto è troppo largo per lo schermo. Per una migliore esperienza di visualizzazione, rimpicciolisci ({{key}} +/-)",
  "week": "Settimana",
  "weekly": "Settimanale",
  "weeks": "settimana/e",
  "withConnections": "con connessioni",
  "workHours": "Ore di Lavoro",
  "workWeek": "Settimana Lavorativa",
  "years": "Anni",
  "yes": "Sì",
  "youAreInSimulationMode": "Sei in modalità simulazione",
  "zeroHours": "0 ore",
  "addCustomer": "Aggiungi cliente",
  "addGlobalChatbot": "Aggiungi chatbot globale",
  "addGlobalRepository": "Aggiungi repository globale",
  "apiKey": "Chiave API",
  "authenticationCode": "Codice di Autenticazione",
  "authenticationCodeSentInfo": "Abbiamo inviato un codice di autenticazione alla tua email. Si prega di inserirlo sopra prima di accedere",
  "chatbotPrefix": "Prefisso Chatbot",
  "chatbotSystemPrompt": "Prompt di Sistema Chatbot",
  "chatbotSystemPrompts": "Prompt di Sistema Chatbot",
  "citationGuidelines": "Linee Guida di Citazione",
  "configureMember": "Configura Membro",
  "createApiKey": "Crea chiave API",
  "creatingProject": "Creazione Progetto",
  "currentQuestion": "Domanda Attuale",
  "customerAdminApiKeyForGlobalRepositories": "Chiave API Admin Cliente per Repository Globali",
  "dateFormatYyyyMmDd": "YYYY-MM-DD",
  "deleteApiKey": "Elimina chiave API",
  "descriptionPrompt": "Prompt Descrizione",
  "editGlobalMessage": "Modifica Messaggio Globale",
  "editingProject": "Modifica Progetto",
  "editSystemPrompts": "Modifica Prompt di Sistema",
  "filePathPrompt": "Prompt Percorso File",
  "fillingInSamples": "Compilazione campioni",
  "generalPrefix": "Prefisso Generale",
  "globalChatbots": "Chatbot Globali",
  "globalRepositories": "Repository Globali",
  "hideNextWeek": "Nascondi Settimana Prossima",
  "hideSatSun": "- Sab/Dom",
  "manageAdmins": "Gestisci Admin",
  "oneWeek": "1 Settimana",
  "openMetricsPanel": "Apri Pannello Metriche/IAP",
  "openTodoList": "Apri Lista TODO",
  "optimizedQuestionPrompt": "Prompt Domanda Ottimizzato",
  "plannertech": "Plannertech",
  "plannertechSuite": "Suite Plannertech",
  "plannertechTeamPlan": "Piano Team Plannertech",
  "previousConversation": "Conversazione Precedente",
  "librarianLogoAlt": "Logo Librarian",
  "qcLibrarianForCompany": "QC Librarian {{company}}",
  "relevantDocumentation": "Documentazione Rilevante",
  "repositoryHasUnprocessedFilesInfo": "Ci sono file non elaborati in questo repository",
  "repositoryIsEmpty": "Questo repository è vuoto",
  "repositoryPrefix": "Prefisso Repository",
  "repositoryProcessingInProgressInfo": "Il repository è attualmente in elaborazione dei file. Si prega di aggiornare la pagina per vedere i progressi",
  "sampleAllocation": "Allocazione Campione",
  "mbWithValue": "{{value}} MB",
  "seatsWithCount": "Posti: {{count}}",
  "excludingToday": "Escludendo oggi",
  "unplanning": "Togliere dal Piano",
  "activeSeats": "Posti attivi: {{count}}",
  "totalSeats": "Posti normali: {{count}}",
  "purchasedSeats": "Posti acquistati: {{count}}",
  "globalMessage": "Messaggio Globale",
  "clearGlobalMessageConfirm": "Sei sicuro di voler cancellare il messaggio globale? Questo farà scomparire il messaggio per tutti gli utenti.",
  "samplesCount": "Campioni: {{count}}",
  "locations": "Posizioni",
  "customers": "Clienti",
  "editCustomer": "Modifica cliente",
  "addCustomerTitle": "Aggiungi Cliente",
  "deleteCustomer": "Elimina Cliente",
  "customerName": "Nome Cliente",
  "customerStatus": "Stato cliente",
  "active": "Attivo",
  "passive": "Passivo",
  "allowedDomains": "Domini Consentiti",
  "allowedPerformers": "Esecutori consentiti",
  "seatsPurchased": "Posti acquistati",
  "customerApiKey": "Chiave API Cliente",
  "durationFormatDDHH": "GG:HH",
  "durationFormatHHMMSS": "HH:MM:SS",
  "durationFormatHHMM": "HH:MM",
  "durationFormatHH": "HH",
  "durationFormatDDHHMM": "GG:HH:MM",
  "continue": "Continua",
  "showNextWeek": "Mostra Settimana Prossima",
  "showSatSun": "+ Sab/Dom",
  "topDescriptionPrompt": "Prompt Descrizione Superiore",
  "twoWeeks": "2 Settimane",
  "updateHelpPage": "Aggiorna Pagina di Aiuto",
  "userAlreadyLoggedInTakeOver": "Utente già connesso. Per assumere la sessione premi conferma",
  "zoomIn": "Zoom Avanti",
  "zoomOut": "Zoom Indietro",
  "constraintWarningTitle": "{{count}} avvertimento/i sono accaduti",
  "assetStatusFree": "Libero",
  "assetStatusBooked": "Prenotato",
  "dateTo": "a",
  "futureAnalysisTaskCantBeFinished": "Un'attività di Analisi futura non può essere terminata",
  "tableNotFound": "Tabella non trovata",
  "conversionSheetFilename": "Foglio di Conversione.xlsx",
  "selectTeam": "Select a team to log in to",
  "admin": "Admin",
  "customerAdmin": "Admin Cliente",
  "attachFile": "Allega file",
  "removeFile": "Rimuovi file",
  "fileTooLarge": "Il file è troppo grande (max 10 MB)",
  "tooManyFiles": "Massimo 3 file per messaggio",
  "unsupportedFileType": "Tipo di file non supportato. Consentiti: PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
